import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { usePrefixCls } from '../../../config/hooks/usePrefixCls';
import { classnames } from '../../../utils';
import { SimpleEmptyImage } from './SimpleEmptyImage';
export var PRESENTED_IMAGE_DEFAULT = React.createElement(SimpleEmptyImage, null);
export var EmptyImpl = function EmptyImpl(props) {
  var _props$description = props.description,
    description = _props$description === void 0 ? '暂无数据' : _props$description,
    _props$image = props.image,
    image = _props$image === void 0 ? PRESENTED_IMAGE_DEFAULT : _props$image,
    imageStyle = props.imageStyle,
    className = props.className,
    style = props.style,
    children = props.children;
  var prefixCls = usePrefixCls('empty');
  var cls = classnames(prefixCls, _defineProperty({}, "".concat(prefixCls, "-normal"), image === PRESENTED_IMAGE_DEFAULT), className);
  var imageNode = null;
  if (typeof image === 'string') {
    imageNode = React.createElement("img", {
      alt: "\u6682\u65E0\u6570\u636E",
      src: image
    });
  } else {
    imageNode = image;
  }
  return React.createElement("div", {
    className: cls,
    style: style
  }, React.createElement("div", {
    className: "".concat(prefixCls, "-image"),
    style: imageStyle
  }, imageNode), description && React.createElement("div", {
    className: "".concat(prefixCls, "-description")
  }, description), children && React.createElement("div", {
    className: "".concat(prefixCls, "-footer")
  }, children));
};